import { render, staticRenderFns } from "./ehc-tooltip.vue?vue&type=template&id=c6f2228e"
import script from "./ehc-tooltip.vue?vue&type=script&lang=js"
export * from "./ehc-tooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports